import * as Yup from 'yup'
import { toEnglishDigits } from 'utilities/helper/toEnglishNumber'

// The same three limits MoneypoolAddLoanDemandActivity.preRequestCheck()
// enforces on Android. The backend only rejects amount<=0 and
// num_repayments<=0 (moneypool_management/validators.py), so without these the
// PWA happily creates 50 instalments of 1,000 تومان — and a zero repayment
// count comes back as a bare 406 that renders as «خطایی رخ داده!».
export const MIN_LOAN_AMOUNT = 5_000
export const MIN_INSTALLMENT_AMOUNT = 5_000
export const MAX_REPAYMENTS = 60

const asNumber = (value: unknown) =>
    Number(toEnglishDigits(String(value ?? ''))) || 0

export const Schema = Yup.object().shape({
    amount: Yup.string()
        .required('مبلغ وام الزامی می باشد')
        .test(
            'min-amount',
            `حداقل مبلغ وام ${MIN_LOAN_AMOUNT.toLocaleString('fa-IR')} تومان است`,
            (value) => asNumber(value) >= MIN_LOAN_AMOUNT
        ),
    num_repayments: Yup.string()
        .required('اعداد اقساط الزامی می باشد')
        .test(
            'not-zero',
            'تعداد اقساط نمی‌تواند صفر باشد',
            (value) => asNumber(value) > 0
        )
        .test(
            'max-repayments',
            `حداکثر تعداد اقساط ${MAX_REPAYMENTS} است`,
            (value) => asNumber(value) <= MAX_REPAYMENTS
        )
        .test(
            'min-installment',
            `مبلغ هر قسط نباید کمتر از ${MIN_INSTALLMENT_AMOUNT.toLocaleString(
                'fa-IR'
            )} تومان باشد`,
            function (value) {
                const repayments = asNumber(value)
                const amount = asNumber(this.parent?.amount)
                if (repayments <= 0 || amount <= 0) {
                    // the other rules already have something to say here
                    return true
                }
                return amount / repayments >= MIN_INSTALLMENT_AMOUNT
            }
        ),
})

export const RequestNewLoanOptions: Array<ISelectOption> = [
    { label: 'فوری(کمتر از 3 روز)', value: 'URGENT' },
    { label: 'بالا(بین 3 تا 10 روز)', value: 'HIGH' },
    { label: 'متوسط(بین 10 تا 30 روز)', value: 'MID' },
    { label: 'پایین(بیشتر از 30 روز)', value: 'LOW' },
]
